import { Link } from "@tanstack/react-router";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { getQuarterLabel } from "@/lib/status-machine";
import type { QuarterlyReview, QuarterlyReviewStatus } from "@/types/entities";

const REVIEW_STATUS_LABELS: Record<QuarterlyReviewStatus, string> = {
  pending_self_reflection: "Pending Self-Reflection",
  pending_supervisor_feedback: "Pending Supervisor Feedback",
  finalized: "Finalized",
};

const REVIEW_STATUS_VARIANTS: Record<QuarterlyReviewStatus, "secondary" | "info" | "accent"> = {
  pending_self_reflection: "secondary",
  pending_supervisor_feedback: "info",
  finalized: "accent",
};

interface ReviewCardProps {
  review: QuarterlyReview;
}

export function ReviewCard({ review }: ReviewCardProps) {
  return (
    <Link to="/reviews/$id" params={{ id: review.id }}>
      <Card className="transition-colors hover:bg-[hsl(var(--muted))]">
        <CardContent className="py-4">
          <div className="flex items-center justify-between">
            <div className="space-y-1">
              <p className="font-medium">
                {review.year} {getQuarterLabel(review.quarter, review.year)}
              </p>
              <p className="text-xs text-[hsl(var(--muted-foreground))]">
                Created {new Date(review.created_at).toLocaleDateString()}
              </p>
            </div>
            <Badge variant={REVIEW_STATUS_VARIANTS[review.status]}>
              {REVIEW_STATUS_LABELS[review.status]}
            </Badge>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
